// extracted by mini-css-extract-plugin
export default {"label":"TeamIconEditor-module__label--ei7GM","animatedBackground":"TeamIconEditor-module__animatedBackground--cL1Ha"};